import React, {  } from 'react'
import { Link, useLocation } from 'react-router-dom'


export const AdvertHeader = ({promotersAccess}) => {

    const location = useLocation();
    const curPath = location.pathname;

    return (
      <div className='advert__header dark-theme-bg1'>
        <div className="container">
          <nav className="advert__nav">
              {promotersAccess && <Link to="/advert/proms" className={`advert__nav-item ${curPath.split('/')[2] === 'proms' ? 'active' : ''}`}>
                  Промы
              </Link>}
              <Link to="/advert/map" className={`advert__nav-item ${curPath.split('/')[2] === 'map' ? 'active' : ''}`}>
                  Карта
              </Link>
              <Link to="/advert/active_routes" className={`advert__nav-item ${curPath.split('/')[2] === 'active_routes' ? 'active' : ''}`}>
                  Активные маршруты
              </Link>
              <Link to="/advert/spread_flyers" className={`advert__nav-item ${curPath.split('/')[2] === 'spread_flyers' ? 'active' : ''}`}>
                  Разнесенный материал
              </Link>
              <Link to="/advert/given_flyers" className={`advert__nav-item ${curPath.split('/')[2] === 'given_flyers' ? 'active' : ''}`}>
                  Выданный материал
              </Link>
              <Link to="/advert/interviews" className={`advert__nav-item ${curPath.split('/')[2] === 'interviews' ? 'active' : ''}`}>
                  Собесы
              </Link>
              <Link to="/advert/payment_routes" className={`advert__nav-item ${curPath.split('/')[2] === 'payment_routes' ? 'active' : ''}`}>
                  Маршруты на оплату
              </Link>
          </nav>
        </div>
      </div>
    )
}
